/**
 * 表盘表达式模版
 */
export class SkuService {
  static LAYER_JSON = 'layer.json';
  static RESOURCES_JSON = 'resources.json';
  private baseUrl =
    'https://watchface-editor-release.cnbj1.mi-fds.com/watchface-editor-release/sku';
  private jsonFilename = 'sku.config.json';

  /**
   * 获取对应类型的预置表带资源
   * @returns
   */
  async getSkuImages(type: string) {
    try {
      const res: {
        name: string;
        url: string;
      }[] = [];
      const url =
        this.baseUrl + '/' + this.jsonFilename + '?_key=' + Math.random();
      const data: string[] = await fetch(url)
        .then((r) => r.json())
        .then((r) => r[type?.toLowerCase()]);
      data?.forEach((item) => {
        res.push({
          url: this.baseUrl + '/' + item,
          name: item.split('/')?.[1].split('.')?.[0] ?? ''
        });
      });
      return res;
    } catch (error) {
      console.log(error);
      return [];
    }
  }
}
